import React from "react";
import qs from "qs";
import get from "lodash/get";
import map from "lodash/map";
import sortBy from "lodash/sortBy";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Icon,
  Layout,
  Modal,
  Tooltip,
  Table,
  Switch,
  message,
  List,
  Card,
  Tag,
  Row,
  Col,
  Badge, notification,
} from "antd";
import classnames from "classnames";
import moment from "moment-timezone";

import PatientProfileFormRandomization from "../../components/PatientProfileForm/PatientProfileFormRandomization";
import PatientProfileEventSummary from "../../components/PatientProfileForm/PatientProfileEventSummary";
import PatientIBMProcessing from "../../components/PatientProfileForm/PatientIBMProcessing";
import FormBuilderCustomViewContainer from "../../containers/FormBuilder/FormBuilderCustomViewContainer";
import QualityControlForm from "../../components/QualityControlForm/QualityControlForm";
import SpecimenSample from "./SpecimenSample/SpecimenSample";
import classes from "./PatientProfile.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getSubjectRequest,
  deletePatientProfileDocumentRequest,
  activatePatientProfileDocumentRequest,
  getEventsForPatient,
  resendConsentNotification,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { getSettingsSites } from "../../reducers/sites/actions";

import { getSettingsDispensingSites } from "../../reducers/sites/selectors";
import {
  getPatientProfileReadPermission,
  gePatientProfileRegistryIdPermission,
  getPatientProfileUpdatePermission,
  getUnblindingRequestReadPermission,
  getProfileDrugReallocatePermission,
  getApiIbmUpdatePermission,
  getApiEcoaUpdatePermission,
  getApiImednetUpdatePermission,
  getUserTimezone,
  getUserShortTimezone,
  getPatientDocumentCreatePermission,
  getPatientDocumentReadPermission,
  getCustomFormPermissionBySlug,
  getProjectConfigurationPreRandomization,
  getDrugManagementStatus,
  getValidationRequiredStatus,
  getApiDatafaxUpdatePermission,
  getConsentAccessPermission,
  getValidateRandomizationAccessPermission,
  getSpecimenSampleReadPermission,
  getSAEReadPermission, getRunDFDiscoverApiConfigPermission, getRunRedcapApiConfigPermission,
} from "../../reducers/user/selectors";
import PatientRegistryForm from "../../components/PatientProfileForm/PatientRegistryForm";
import RandomizeAdmin from "../../containers/RandomizeAdmin/RandomizeAdmin";
import PatientReallocationForm from "../../components/PatientProfileForm/PatientReallocationForm";
import DocumentPatientForm, {
  documentTypes,
} from "../../components/DocumentForm/DocumentPatientForm";
import { withNamespaces } from "react-i18next";
import FileLink from "../../components/FileLink/FileLink";
import { Fragment } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import { Link, NavLink } from "react-router-dom";
import { withParams } from "../../utils/url";

const routes = require("../../routes.json");

const { Content } = Layout;

class PatientProfile extends React.Component {
  constructor(props) {
    super(props);

    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      subject: null,
      subjectSearch: null,
      subjectID: null,
      errorMessage: null,
      responseMessage: null,
      show_voided: queryParams.get("show_voided"),
      isLoading: false,
      showRegistryForm: false,
      showPatientProfileForm: true,
      showReallocationForm: false,
      showRandomizeForm: true,
      showPreRandomizeForm: false,
      showValidateRandomization: false,
      randomized: null,
      showProfileForm: true,
      showIbmForm: false,
      showEvents: true,
      showMilestones: true,
      events: [],
      showDocumentsSection: false,
      order: null,
      formEventSlug: null,
      formEventSlugPreview: null,
      formIssuePreview: null,
      sortedInfo: { columnKey: "order_index", order: null },
      saeCases: {
        symptomatic_intracerebral: this.props.i18n.t(
          "NamespaceSAEReportingForm:Symptomatic intracerebral hemorrhage"
        ),
        peripheral_bleeding: this.props.i18n.t(
          "NamespaceSAEReportingForm:Peripheral bleeding requiring blood transfusion"
        ),
        angioedema: this.props.i18n.t("Angioedema"),
        other: this.props.i18n.t(
          "NamespaceSAEReportingForm:Others (give diagnosis, if possible)"
        ),
        none: this.props.i18n.t("None"),
      },
    };
  }

  async componentDidMount() {
    const subjectID = get(this.props, "match.params.subjectID");
    this.props.getSettingsSites();

    if (subjectID) {
      await this.onSubjectSearch(subjectID);
      this.setState({ subjectSearch: subjectID });
      await this.getEvents();

      this.setState({
        formEventSlug: get(
          qs.parse(this.props.location.search.replace("?", "")),
          "followup_type",
          null
        ),
      });
    }
  }

  getEvents = async () => {
    this.setState({ isLoading: true });

    try {
      const { data } = await getEventsForPatient(
        this.state.subject.profile.code
      );

      this.setState({
        events: data,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }

    this.setState({ isLoading: false });
  };

  eventStatuses = () => {
    return {
      pending: {
        label: this.props.i18n.t("Pending"),
        color: "#8b8b8d",
      },
      not_required: {
        label: this.props.i18n.t("Not required"),
        color: "#000080",
      },
      missed: {
        label: this.props.i18n.t("Missing"),
        color: "#A020F0",
      },
      in_progress: {
        label: this.props.i18n.t("In progress"),
        color: "#fda048",
      },
      completed: {
        label: this.props.i18n.t("Completed"),
        color: "#41bf2f",
      },
      death_completed: {
        label: this.props.i18n.t("Patient deceased"),
        color: "#EC6C67",
      },
      patient_death: {
        label: this.props.i18n.t("Dead"),
        color: "#EC6C67",
      },
      patient_deceased: {
        label: this.props.i18n.t("Not required - patient deceased"),
        color: "#EC6C67",
      },
    };
  };

  fetchCurrentSubject({ withLoading = true } = {}) {
    const subjectID = get(this.props, "match.params.subjectID");

    if (subjectID) {
      this.onSubjectSearch(subjectID, { withLoading });
      this.setState({ subjectSearch: subjectID });
    }
  }

  onSubjectSearch = async (value, skipLock) => {
    if (value.trim()) {
      this.setState({
        errorMessage: null,
        subject: null,
        isLoading: true,
        responseMessage: null,
      });

      if (typeof skipLock === "boolean") {
        await this.getSubject(value, skipLock);
      } else {
        await this.getSubject(value);
      }

      this.setState({ isLoading: false });
    }
  };

  getSubject = async (value, skipLock, isSilent) => {
    const queryParams = new URLSearchParams(this.props.location.search);

    try {
      if (!isSilent) {
        this.setState({ showProfileForm: false });
      }
      const { data } = await getSubjectRequest(value, skipLock, queryParams.get("show_voided") || undefined);
      this.setState({
        subjectID: get(data, "profile.code"),
        subject: {
          ...data,
          profile: data.profile ? { ...data.profile } : null,
        },
        showProfileForm: true,
        showRandomizeForm: !data.randomization_conducted,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });

      setTimeout(() => {
        this.props.history.push(routes.admin.enrolments);
      }, 1500);
    }
  };

  onSubjectClear = () => {
    this.setState({
      subject: null,
      subjectSearch: null,
    });
  };

  onProfileDelete = () => {
    this.setState({
      responseMessage: this.props.i18n.t("Successfully deactivated"),
    });
  };

  onSubjectChange = (e) => {
    this.setState({ subjectSearch: e.target.value });
  };

  collapseSection = (sectionName) => () => {
    this.setState((state) => ({ [sectionName]: !state[sectionName] }));
  };

  onRandomized = (randomized) => {
    this.setState({ randomized });
  };

  addDocument = () => {
    this.setState({ documentEdit: {} });
  };

  onDocumentEdit = (document) => () => {
    this.setState({ documentEdit: document });
  };

  onDocumentEditHide = () => {
    this.setState({ documentEdit: null });
  };

  onDocumentEditSubmit = () => {
    this.setState({ documentEdit: null }, () => {
      this.fetchCurrentSubject({ withLoading: false });
    });
  };

  onSwitchDocumentActivation = (id, state) => async () => {
    try {
      if (state === "active") {
        await deletePatientProfileDocumentRequest(id);
      } else {
        await activatePatientProfileDocumentRequest(id);
      }

      message.success(this.props.i18n.t("Saved"));

      this.fetchCurrentSubject({ withLoading: false });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(this.props.i18n.t("Error"));
      console.log(e);
    }
  };

  eventColumns() {
    return [
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("NamespacePatientProfile:Form"),
        render: (val, row) => <span>{row.form.name}</span>,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Status"),
        render: (val, row) =>
          this.eventStatuses()[val] &&
          !(val === "pending" && row.form.slug === "death") && (
            <Badge
              style={{
                backgroundColor: this.eventStatuses()[
                  val === "completed" && row.form.slug === "death"
                    ? "death_completed"
                    : val
                ].color,
              }}
              count={
                this.eventStatuses()[
                  val === "completed" && row.form.slug === "death"
                    ? "death_completed"
                    : val
                ].label
              }
            />
          ),
      },
      {
        dataIndex: "actions",
        key: "actions",
        render: (val, row) => (
          <div style={{ textAlign: "center" }}>
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("NamespacePatientProfile:Edit")}
            >
              <Icon
                type="edit"
                theme="filled"
                style={{ fontSize: "18px" }}
                onClick={() => {
                  this.setState({ formEventSlug: get(row, "form.slug") });
                }}
              />
            </Tooltip>
            {row.state !== "pending" && (
              <Fragment>
                &nbsp;&nbsp;
                <Tooltip
                  placement="topLeft"
                  title={this.props.i18n.t("NamespacePatientProfile:View")}
                >
                  <Icon
                    type="eye"
                    theme="filled"
                    onClick={() => {
                      this.setState({
                        formEventSlugPreview: get(row, "form.slug"),
                      });
                    }}
                  />
                </Tooltip>
              </Fragment>
            )}
            <Fragment>
              &nbsp;&nbsp;
              <Tooltip
                placement="topLeft"
                title={this.props.i18n.t("NamespacePatientProfile:Add issue")}
              >
                <Icon
                  type="exclamation-circle"
                  theme="filled"
                  onClick={() => {
                    this.setState({ formIssuePreview: get(row, "form") });
                  }}
                />
              </Tooltip>
            </Fragment>
          </div>
        ),
      },
    ];
  }

  eventsChildColumns() {
    return [
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("NamespacePatientProfile:Event"),
        render: (val, row) => (
          <span>
            {row.name}
            {row.required_for_completion && (
              <span>
                &nbsp;
                <Icon
                  type="exclamation-circle"
                  title={this.props.i18n.t("Required")}
                  style={{ color: "#c26a00" }}
                />
              </span>
            )}
            {!!row.ready_for_billing && (
              <span>
                &nbsp;
                <Icon
                  type="dollar"
                  title={this.props.i18n.t("Ready for billing")}
                  style={{ color: "#41bf2f" }}
                />
              </span>
            )}
          </span>
        ),
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Status"),
        render: (val) =>
          this.eventStatuses()[val] && (
            <Badge
              style={{ backgroundColor: this.eventStatuses()[val].color }}
              count={this.eventStatuses()[val].label}
            />
          ),
      },
    ];
  }

  documentColumns() {
    return [
      {
        dataIndex: "order_index",
        key: "order_index",
        title: this.props.i18n.t("Index"),
        render: (val) => <span>{val}</span>,
        sorter: true,
        sortOrder:
          get(this.state.sortedInfo, "columnKey") === "order_index" &&
          this.state.sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("Document Name"),
        render: (val, record) => <div>{val}</div>,
      },
      {
        dataIndex: "category",
        key: "category",
        title: this.props.i18n.t("NamespacePatientProfile:Document Category"),
        render: (val, record) => (
          <div>
            {this.props.i18n.t("NamespacePatientProfile:Patient documents")}
          </div>
        ),
      },
      {
        dataIndex: "type",
        key: "type",
        title: this.props.i18n.t("Document Type"),
        render: (val, record) => <div>{documentTypes[val]}</div>,
      },
      {
        dataIndex: "start_year",
        key: "start_year",
        title: this.props.i18n.t("Start date"),
      },
      {
        dataIndex: "expiry_year",
        key: "expiry_year",
        title: this.props.i18n.t("Expiry date"),
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Actions"),
        render: (val, document) => (
          <div className={classes.actions}>
            <span style={{ position: "relative", top: "8px" }}>
              <FileLink url={document.url} private_url={document.private_url} />
            </span>
            &nbsp; &nbsp;
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("NamespacePatientProfile:Edit Document")}
            >
              <Icon
                type="edit"
                theme="filled"
                onClick={this.onDocumentEdit(document)}
              />
            </Tooltip>
            &nbsp; &nbsp;
            <Tooltip
              placement="topLeft"
              title={this.props.i18n.t("Activate / Deactivate Document")}
            >
              <Switch
                checked={document.state === "active"}
                onChange={this.onSwitchDocumentActivation(val, document.state)}
              />
            </Tooltip>
          </div>
        ),
      },
    ];
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter,
      order:
        get(sorter, "order") === "ascend"
          ? "asc"
          : get(sorter, "order") === "descend"
          ? "desc"
          : "asc",
    });
  };

  resendConsentEmail = async (consentID) => {
    this.setState({
      resendConsentNotificationLoading: true
    });

    try {
      await resendConsentNotification(consentID);
      notification.success({
        message: this.props.i18n.t("Success"),
      });

      this.setState({
        resendConsentNotificationSuccess: true
      });
    } catch (e) {
      notification.error({
        message: this.props.i18n.t("Something went wrong"),
      });
    }

    this.setState({
      resendConsentNotificationLoading: false
    });
  };

  render() {
    const {
      order,
      sortedInfo,
      documentEdit,
      subject,
      subjectID,
      errorMessage,
      isLoading,
      responseMessage,
      showDocumentsSection,
      showRegistryForm,
      showPatientProfileForm,
      showRandomizeForm,
      showReallocationForm,
      showPreRandomizeForm,
      showValidateRandomization,
      showIbmForm,
      randomized,
      showEvents,
      showMilestones,
      formEventSlug,
      formEventSlugPreview,
      formIssuePreview,
      saeCases,
      resendConsentNotificationSuccess,
      resendConsentNotificationLoading
    } = this.state;
    const {
      projectConfigurationPreRandomization,
      patientProfileReadPermission,
      unblindingRequestReadPermission,
      patientProfileUpdatePermission,
      patientDocumentCreatePermission,
      apiIbmUpdatePermission,
      apiEcoaUpdatePermission,
      apiImednetUpdatePermission,
      apiDatafaxUpdatePermission,
      dispensingSites,
      userShortTimezone,
      userTimezone,
      isValidationRequired,
    } = this.props;

    const profile = get(subject, "profile");
    const current_drug = get(subject, "drug");
    const locked = get(subject, "profile.locked");

    const isEditable = get(subject, "randomization_conducted") && (
      (patientProfileUpdatePermission && profile && !locked) ||
      (patientProfileUpdatePermission &&
        profile &&
        locked &&
        profile.allow_to_edit));

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespacePatientProfile:Subject Profile")}
            </h3>

            {!patientProfileReadPermission && (
              <Alert
                type="error"
                message={this.props.i18n.t(
                  "Permission denied! You cannot perform this action."
                )}
              />
            )}

            {patientProfileReadPermission && (
              <div>
                {/*<div className={classes.searchWrapper}>
                        <label>
                          <b className={classes.searchWrapperLabel}>{this.props.i18n.t("SEARCH")}</b>
                          <Search
                            placeholder={this.props.i18n.t("By SubjectID or Profile ID")}
                            enterButton="Search"
                            size="large"
                            onSearch={this.onSubjectSearch}
                            value={subjectSearch}
                            onChange={this.onSubjectChange}
                            style={{ maxWidth: '500px'}}
                          />
                        </label>
                      </div>*/}

                <div>
                  <h4 className="headline-default">
                    {this.props.i18n.t("Subject ID")}: {get(subject, "code")}
                  </h4>
                </div>

                {errorMessage && <Alert type="error" message={errorMessage} />}

                {responseMessage && (
                  <Alert type="success" message={responseMessage} />
                )}

                {get(subject, "created") && (
                  <Alert
                    type="success"
                    style={{ maxWidth: "360px" }}
                    message={
                      <div>
                        <b>{this.props.i18n.t("Created")}:</b>{" "}
                        {moment
                          .utc(get(subject, "created"))
                          .tz(
                            userTimezone ||
                              get(subject, "site.time_zone") ||
                              "UTC"
                          )
                          .format("YYYY/MM/DD HH:mm")}
                        &nbsp;
                        {userShortTimezone ||
                          get(subject, "site.short_tz") ||
                          "UTC"}
                        {get(subject, "updated") && (
                          <span>
                            <br />
                            <b>
                              {this.props.i18n.t(
                                "NamespacePatientProfile:Last updated"
                              )}
                              :
                            </b>{" "}
                            {moment
                              .utc(get(subject, "updated"))
                              .tz(
                                userTimezone ||
                                  get(subject, "site.time_zone") ||
                                  "UTC"
                              )
                              .format("YYYY/MM/DD HH:mm")}
                            &nbsp;
                            {userShortTimezone ||
                              get(subject, "site.short_tz") ||
                              "UTC"}
                          </span>
                        )}
                      </div>
                    }
                  />
                )}

                <h5 className="headline-default">Patient event tracking</h5>
                <div className={classes.eventStepWrapper}>
                  {this.state.events
                    .filter(
                      ({ tracking_patient_event }) => !!tracking_patient_event
                    )
                    .map((item, index) => (
                      <div
                        className={classnames(classes.eventStepTitle, {
                          [classes.eventStepTitleCompleted]:
                            item.status === "completed",
                          [classes.eventStepTitleInProgress]:
                            item.status === "in_progress",
                          [classes.eventStepTitleMissing]:
                            item.status === "missing",
                          [classes.eventStepTitleFailed]:
                            item.status === "failed",
                        })}
                        key={index}
                      >
                        {item.name}
                      </div>
                    ))}
                </div>

                {subject && (
                  <div className={classes.randomizeFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showMilestones")}
                    >
                      <Tooltip
                        title={
                          showMilestones
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              showMilestones ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t(
                          "NamespacePatientProfile:Milestones"
                        )}
                      </span>
                    </h4>

                    {showMilestones && (
                      <Row gutter={[16, 16]} type="flex">
                        {this.state.events
                          .filter(
                            (item) =>
                              item.show_on_patient_page &&
                              item.type === "milestone"
                          )
                          .map((item, index) => (
                            <React.Fragment key={index}>
                              <Col span={8}>
                                <Card
                                  title={
                                    <span>
                                      <span
                                        style={{
                                          fontSize: "13px",
                                          color: "#777",
                                          margin: "0 3px 0 0",
                                        }}
                                      >
                                        #{index + 1}{" "}
                                      </span>
                                      {item.name}{" "}
                                      {item.status == "completed" && (
                                        <CheckCircleFilled
                                          className={classes.checkIcon}
                                        />
                                      )}
                                      {item.type === "milestone" && (
                                        <span>
                                          <Tag color="#2968ae">{this.props.i18n.t("Milestone")}</Tag>
                                          {!!item.ready_for_billing && (
                                            <span>
                                              &nbsp;
                                              <Icon
                                                type="dollar"
                                                title={this.props.i18n.t(
                                                  "Ready for billing"
                                                )}
                                                style={{ color: "#41bf2f" }}
                                              />
                                            </span>
                                          )}
                                        </span>
                                      )}
                                    </span>
                                  }
                                  bodyStyle={{ padding: 0 }}
                                  style={{ height: "100%" }}
                                >
                                  {item.child_events && (
                                    <Table
                                      style={{ borderBottom: 0 }}
                                      dataSource={sortBy(
                                        item.child_events,
                                        (item) => item.order_index
                                      )}
                                      rowKey={(item) => item.id}
                                      columns={this.eventsChildColumns()}
                                      pagination={false}
                                    />
                                  )}
                                </Card>
                              </Col>
                            </React.Fragment>
                          ))}
                      </Row>
                    )}
                  </div>
                )}

                {subject && (
                  <div className={classes.randomizeFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showEvents")}
                    >
                      <Tooltip
                        title={
                          showEvents
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${showEvents ? "0" : "180deg"})`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("NamespacePatientProfile:Events")}
                      </span>
                    </h4>

                    {showEvents && (
                      <Row gutter={[16, 16]} type="flex">
                        {this.state.events
                          .filter(
                            (item) =>
                              item.show_on_patient_page &&
                              item.type !== "milestone"
                          )
                          .map((item, index) => (
                            <React.Fragment key={index}>
                              {["milestone", "hardcoded_consent"].includes(
                                item.type
                              ) && <Col span={24} />}
                              <Col span={8}>
                                <Card
                                  title={
                                    <span>
                                      <span
                                        style={{
                                          fontSize: "13px",
                                          color: "#777",
                                          margin: "0 3px 0 0",
                                        }}
                                      >
                                        #{index + 1}{" "}
                                      </span>
                                      {item.name}{" "}
                                      {item.status == "completed" && (
                                        <CheckCircleFilled
                                          className={classes.checkIcon}
                                        />
                                      )}
                                      {item.type === "milestone" && (
                                        <span>
                                          <Tag color="#2968ae">{this.props.i18n.t("Milestone")}</Tag>
                                          {!!item.ready_for_billing && (
                                            <span>
                                              &nbsp;
                                              <Icon
                                                type="dollar"
                                                title={this.props.i18n.t(
                                                  "Ready for billing"
                                                )}
                                                style={{ color: "#41bf2f" }}
                                              />
                                            </span>
                                          )}
                                        </span>
                                      )}
                                    </span>
                                  }
                                  bodyStyle={{ padding: 0 }}
                                  style={{ height: "100%" }}
                                >
                                  {item.child_events && (
                                    <Table
                                      style={{ borderBottom: 0 }}
                                      dataSource={sortBy(
                                        item.child_events,
                                        (item) => item.order_index
                                      )}
                                      rowKey={(item) => item.id}
                                      columns={this.eventsChildColumns()}
                                      pagination={false}
                                    />
                                  )}

                                  {!item.hardcoded_form && !item.child_events && (
                                    <Table
                                      style={{ borderBottom: 0 }}
                                      dataSource={item.form_events.filter(
                                        (item) =>
                                          getCustomFormPermissionBySlug({
                                            slug: get(item, "form.slug"),
                                            type: "read",
                                          })(this.props.state)
                                      )}
                                      rowKey={(item, index) => item.form.id}
                                      columns={this.eventColumns()}
                                      pagination={false}
                                    />
                                  )}

                                  {item.codename === "validation" &&
                                    (this.props
                                      .validateRandomizationAccessPermission ? (
                                      <div>
                                        {item.status === "completed" && (
                                          <Table
                                            style={{ borderBottom: 0 }}
                                            dataSource={[
                                              {
                                                title: this.props.i18n.t(
                                                  "Status"
                                                ),
                                                description: item.status,
                                              },
                                              {
                                                title: this.props.i18n.t(
                                                  "Validation date"
                                                ),
                                                description: `${moment
                                                  .utc(
                                                    item.validationExistsDate
                                                  )
                                                  .tz(
                                                    userTimezone ||
                                                      get(
                                                        subject,
                                                        "site.time_zone"
                                                      ) ||
                                                      "UTC"
                                                  )
                                                  .format(
                                                    "YYYY/MM/DD HH:mm"
                                                  )} ${
                                                  userShortTimezone ||
                                                  get(
                                                    subject,
                                                    "site.short_tz"
                                                  ) ||
                                                  "UTC"
                                                }`,
                                              },
                                              {
                                                title: this.props.i18n.t(
                                                  "Validation comments"
                                                ),
                                                description:
                                                  item.data
                                                    .validationExistsComments,
                                              },
                                              {
                                                title: this.props.i18n.t(
                                                  "Protocol deviation comments"
                                                ),
                                                description:
                                                  item.data
                                                    .validationDeviationExistsComments,
                                              },
                                              {
                                                title: this.props.i18n.t(
                                                  "Patient death comments"
                                                ),
                                                description:
                                                  item.data
                                                    .validationPatientDiedComments,
                                              },
                                            ]}
                                            rowKey={(item, index) => item.title}
                                            columns={[
                                              {
                                                dataIndex: "title",
                                                key: "title",
                                                title: this.props.i18n.t(
                                                  "NamespacePatientProfile:Title"
                                                ),
                                                render: (val, row) => (
                                                  <span>{val}</span>
                                                ),
                                              },
                                              {
                                                dataIndex: "description",
                                                key: "description",
                                                title: this.props.i18n.t(
                                                  "Description"
                                                ),
                                                render: (val) => val,
                                              },
                                            ]}
                                            pagination={false}
                                          />
                                        )}

                                        {item.status !== "completed" && (
                                          <div style={{ margin: "20px" }}>
                                            <div style={{ margin: "0 0 5px" }}>
                                              {this.props.i18n.t(
                                                "Validation is not conducted"
                                              )}
                                            </div>

                                            <Link
                                              to={withParams(
                                                routes.admin
                                                  .validateRandomizationAdmin,
                                                {
                                                  subjectID: get(
                                                    subject,
                                                    "code"
                                                  ),
                                                  site: get(
                                                    subject,
                                                    "site.code"
                                                  ),
                                                }
                                              )}
                                            >
                                              <Button
                                                size="small"
                                                type="primary"
                                              >
                                                {this.props.i18n.t("Validate")}
                                              </Button>
                                            </Link>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div style={{ margin: "24px" }}>
                                        {this.props.i18n.t("No access")}
                                      </div>
                                    ))}
                                  {item.codename === "consent" &&
                                    (this.props.consentAccessPermission ? (
                                      <div style={{ margin: "20px" }}>
                                        {item.data &&
                                        item.data.consentExistsLink &&
                                        item.data.consentExistsLink.length >
                                          0 ? (
                                          map(
                                            item.data.consentExistsLink,
                                            (
                                              { link, name, private_url },
                                              i
                                            ) => (
                                              <div key={i}>
                                                {link ? (
                                                  <FileLink
                                                    url={link}
                                                    private_url={private_url}
                                                    text={name}
                                                  />
                                                ) : (
                                                  <div
                                                    style={{
                                                      margin: "0 0 10px",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        margin: "0 0 5px",
                                                      }}
                                                    >
                                                      {this.props.i18n.t(
                                                        "Consent file missing."
                                                      )}
                                                    </div>

                                                    {!this.state.show_voided && <Link
                                                      to={withParams(
                                                        routes.admin.consent,
                                                        {
                                                          subjectID: get(
                                                            subject,
                                                            "code"
                                                          ),
                                                          site: get(
                                                            subject,
                                                            "site.code"
                                                          ),
                                                        }
                                                      )}
                                                    >
                                                      <Button
                                                        size="small"
                                                        type="primary"
                                                      >
                                                        {this.props.i18n.t(
                                                          "Provide Consent"
                                                        )}
                                                      </Button>
                                                    </Link>}
                                                  </div>
                                                )}
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <div style={{ margin: "0 0 10px" }}>
                                            {item.data &&
                                            !item.data.details
                                              .consent_upload_later && (
                                              <span>
                                                <div
                                                  style={{ margin: "0 0 5px" }}
                                                >
                                                  {this.props.i18n.t(
                                                    "Consent is not provided"
                                                  )}
                                                </div>
                                              </span>
                                            )}
                                          </div>
                                        )}

                                        { item.status == 'missing' &&
                                          <div style={{ margin: "0 0 10px" }}>
                                            <span>
                                                <div
                                                  style={{ margin: "0 0 5px" }}
                                                >
                                                  {this.props.i18n.t(
                                                    "Consent is missing"
                                                  )}
                                                </div>
                                              </span>
                                          </div>
                                        }
                                        { item.status == 'pending' && !item.data &&
                                          <div style={{ margin: "0 0 10px" }}>
                                            <span>
                                                <div
                                                  style={{ margin: "0 0 5px" }}
                                                >
                                                  {this.props.i18n.t(
                                                    "Consent is pending"
                                                  )}
                                                </div>
                                              </span>
                                          </div>
                                        }
                                        { item.status == 'not_required' && !item.data &&
                                          <div style={{ margin: "0 0 10px" }}>
                                            <span>
                                                <div
                                                  style={{ margin: "0 0 5px" }}
                                                >
                                                  {this.props.i18n.t(
                                                    "Consent is not required"
                                                  )}
                                                </div>
                                              </span>
                                          </div>
                                        }

                                        {!this.state.show_voided && (item.status == 'missing' || (item.status == 'pending' && !item.data) || (item.data && ((item.data.consentExistsLink &&
                                            item.data.consentExistsLink.length <= 0) || (item.data.details.consent_is_needed)) && !item.data.details.consent_upload_later)) &&
                                              <Link
                                                  to={withParams(
                                                    routes.admin.consent,
                                                    {
                                                      subjectID: get(
                                                        subject,
                                                        "code"
                                                      ),
                                                      site: get(
                                                        subject,
                                                        "site.code"
                                                      ),
                                                    }
                                                  )}
                                                >
                                                  <Button
                                                    size="small"
                                                    type="primary"
                                                  >
                                                    {this.props.i18n.t(
                                                      "Provide Consent"
                                                    )}
                                                  </Button>
                                                </Link>
                                            }


                                          { item.data &&
                                          item.data.details.consent_upload_later &&
                                            <div
                                                style={{ margin: "0 0 5px" }}
                                              >
                                                {item.data.consentExistsPersonType} {item.data.consentExistsMethodType} {this.props.i18n.t(
                                                  "consent file upload skipped."
                                                )}
                                            </div>

                                          }
                                          { item.data &&
                                          item.data.details.consent_upload_later &&
                                            <div
                                                style={{ margin: "0 0 5px" }}
                                              >
                                                <Link
                                                  to={withParams(
                                                    routes.admin.consent,
                                                    {
                                                      subjectID: get(
                                                        subject,
                                                        "code"
                                                      ),
                                                      site: get(
                                                        subject,
                                                        "site.code"
                                                      ),
                                                    }
                                                  )}
                                                >
                                                  <Button
                                                    size="small"
                                                    type="primary"
                                                  >
                                                    {this.props.i18n.t(
                                                      "Upload missing consent file"
                                                    )}
                                                  </Button>
                                                </Link>
                                            </div>
                                          }

                                        {item.data &&
                                          item.data
                                            .consentExistsEmailStatus && (
                                            <div>
                                              {item.data
                                                .consentExistsEmailStatus ===
                                                "participant_email_sent" && (
                                                <span>
                                                  {" "}
                                                  {this.props.i18n.t("Waiting for participant signature")}
                                                </span>
                                              )}
                                              {item.data
                                                .consentExistsEmailStatus ===
                                                "investigator_email_sent" && (
                                                <span>
                                                  {" "}
                                                  {this.props.i18n.t("Waiting for investigator signature")}
                                                </span>
                                              )}
                                              {item.data
                                                .consentExistsEmailStatus ===
                                                "investigator_link_expired" && (
                                                <span>
                                                  {" "}
                                                  {this.props.i18n.t("Investigator link expired")}
                                                </span>
                                              )}
                                              {item.data
                                                .consentExistsEmailStatus ===
                                                "link_expired" && (
                                                <span>
                                                  {" "}
                                                  {this.props.i18n.t("Participant link expired")}
                                                </span>
                                              )}
                                            </div>
                                          )}

                                        {
                                          item.data && item.data.consentExistsEmailStatus &&
                                            !["participant_email_sent", "investigator_email_sent", "investigator_link_expired", "link_expired"].includes(item.data.consentExistsEmailStatus) && (
                                            <div>
                                                <span>
                                                  {" "}
                                                  {item.data.consentExistsEmailStatus}
                                                </span>
                                            </div>
                                          )}



                                        {item.data &&
                                          item.data.consentExistsDate && (
                                            <div>
                                              <b>{this.props.i18n.t("Date")}:</b>{" "}
                                              {`${moment
                                                .utc(
                                                  item.data.consentExistsDate
                                                )
                                                .tz(
                                                  userTimezone ||
                                                    get(
                                                      subject,
                                                      "site.time_zone"
                                                    ) ||
                                                    "UTC"
                                                )
                                                .format("YYYY/MM/DD HH:mm")} ${
                                                userShortTimezone ||
                                                get(subject, "site.short_tz") ||
                                                "UTC"
                                              }`}
                                            </div>
                                          )}

                                        {item.data &&
                                          item.data.consentExists && (
                                            <div>
                                              <b>{this.props.i18n.t("Consent exists")}:</b>{" "}
                                              {item.data.consentExists ? this.props.i18n.t('Yes') : this.props.i18n.t('No')}
                                            </div>
                                          )}

                                        {item.data &&
                                        item.data.consentExistsType && (
                                          <div>
                                            <b>{this.props.i18n.t("Consent type")}:</b>{" "}
                                            {item.data.consentExistsType}
                                          </div>
                                        )}

                                        {item.data &&
                                          item.data.consentExistsPersonType && (
                                            <div>
                                              <b>{this.props.i18n.t("Consent person")}:</b>{" "}
                                              {item.data.consentExistsPersonType}
                                            </div>
                                          )}

                                        {item.data &&
                                          item.data.consentExistsMethodType && (
                                            <div>
                                              <b>{this.props.i18n.t("Consent method")}:</b>{" "}
                                              {item.data.consentExistsMethodType}
                                            </div>
                                          )}

                                        {item.data &&
                                          item.data.consentComments && (
                                            <div>
                                              <b>{this.props.i18n.t("Comments")}:</b>{" "}
                                              {item.data.consentComments}
                                            </div>
                                          )}

                                        {item.data &&
                                        item.data.consentTimeSpend ? (
                                          <div>
                                            <b>{this.props.i18n.t("Time spent")}:</b>{" "}
                                            {item.data.consentTimeSpend}s
                                          </div>
                                        ) : (
                                          <div />
                                        )}

                                        {item.data && item.data.can_resend_email && (
                                          <div style={{ marginTop: "5px" }}>
                                            <Button
                                              onClick={() => {
                                                this.resendConsentEmail(
                                                  item.data.consentRecordID
                                                );
                                              }}
                                              size="small"
                                              type="primary"
                                              htmlType="button"
                                              loading={resendConsentNotificationLoading}
                                              disabled={resendConsentNotificationSuccess}
                                            >
                                              {this.props.i18n.t("Resend consent email")}
                                            </Button>
                                          </div>
                                        )}

                                        {item.data &&
                                        item.data.language_code ? (
                                          <div>
                                            <b>{this.props.i18n.t("Language")}:</b>{" "}
                                            {item.data.language_code.toUpperCase()}
                                          </div>
                                        ) : (
                                          <div />
                                        )}

                                        {(item.data && item.data.consentExistsLink &&
                                          item.data.consentExistsLink.length >= 0 && !item.data.details.consent_is_needed && !item.data.details.consent_upload_later && item.data.details.can_update_consent) &&
                                            <div>
                                              <br/>
                                              <Link
                                                to={withParams(routes.admin.consent, {
                                                  subjectID: get(subject, "code"),
                                                  site: get(subject, "site.code"),
                                                })}
                                              >
                                                <Button size="small" type="ghost">
                                                  {this.props.i18n.t("Update consent")}
                                                </Button>
                                              </Link>
                                            </div>
                                        }

                                      </div>
                                    ) : (
                                      <div style={{ margin: "24px" }}>
                                        {this.props.i18n.t("No access")}
                                      </div>
                                    ))}

                                  {item.codename === "sae" &&
                                    (this.props.getSAEReadPermission ? (
                                      <div style={{ margin: "20px" }}>
                                        {item.data && item.data.length > 0 && (
                                          <div>
                                            <div>
                                              <b>{this.props.i18n.t("SAE date")}:</b>{" "}
                                              {`${moment
                                                .utc(item.data[0].sae_date)
                                                .tz(
                                                  userTimezone ||
                                                    get(
                                                      subject,
                                                      "site.time_zone"
                                                    ) ||
                                                    "UTC"
                                                )
                                                .format("YYYY/MM/DD")} ${
                                                userShortTimezone ||
                                                get(subject, "site.short_tz") ||
                                                "UTC"
                                              }`}
                                            </div>

                                            <div>
                                              <b>{this.props.i18n.t("Is SAE occured")} &nbsp;</b>

                                              <Tag
                                                color={
                                                  item.data[0].is_sae_occurred
                                                    ? "#f00"
                                                    : "#49c850"
                                                }
                                              >
                                                {item.data[0].is_sae_occurred
                                                  ? this.props.i18n.t('Yes') : this.props.i18n.t('No')}
                                              </Tag>
                                            </div>

                                            <div>
                                              <b>{this.props.i18n.t("SAE event")} &nbsp;</b>

                                              <div>
                                                {
                                                  saeCases[
                                                    item.data[0].event_type
                                                  ]
                                                }
                                              </div>
                                            </div>

                                            <div>
                                              <b>{this.props.i18n.t("Is event expected")} &nbsp;</b>

                                              <Tag
                                                color={
                                                  item.data[0]
                                                    .is_adverse_event_expected
                                                    ? "#49c850"
                                                    : "#f00"
                                                }
                                              >
                                                {item.data[0]
                                                  .is_adverse_event_expected
                                                  ? this.props.i18n.t("Yes")
                                                  : this.props.i18n.t("No")}
                                              </Tag>
                                            </div>

                                            <div>
                                              <b>{this.props.i18n.t("Event Comments")}</b>
                                              <div>
                                                {item.data[0].event_comments}
                                              </div>
                                            </div>

                                            <div>
                                              <b>{this.props.i18n.t("Other Comments")}</b>
                                              <div>
                                                {item.data[0].other_comments}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div style={{ margin: "20px" }}>
                                        {this.props.i18n.t("No access")}
                                      </div>
                                    ))}

                                  {item.codename === "death" && (
                                    <div style={{ margin: "20px" }}>
                                      {item.data && item.data.is_deceased && (
                                        <div>
                                          <div>
                                            <b>{this.props.i18n.t("Is Patient Deceased")} &nbsp;</b>

                                            <Tag
                                              color={
                                                item.data.is_deceased
                                                  ? "#f00"
                                                  : "#49c850"
                                              }
                                            >
                                              {item.data.is_deceased
                                                ? "Yes"
                                                : "No"}
                                            </Tag>
                                          </div>

                                          {item.data.is_deceased && (
                                            <div>
                                              <b>{this.props.i18n.t("Death date")}:</b>{" "}
                                              {`${moment
                                                .utc(item.data.death_date)
                                                .tz(
                                                  userTimezone ||
                                                    get(
                                                      subject,
                                                      "site.time_zone"
                                                    ) ||
                                                    "UTC"
                                                )
                                                .format("YYYY/MM/DD HH:mm")} ${
                                                userShortTimezone ||
                                                get(subject, "site.short_tz") ||
                                                "UTC"
                                              }`}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </Card>
                              </Col>
                            </React.Fragment>
                          ))}
                      </Row>
                    )}
                  </div>
                )}

                {subject &&
                  (apiIbmUpdatePermission ||
                    apiEcoaUpdatePermission ||
                    apiImednetUpdatePermission ||
                    getRunRedcapApiConfigPermission ||
                    getRunDFDiscoverApiConfigPermission ||
                    apiDatafaxUpdatePermission) && (!this.state.show_voided) && (
                    <div className={classes.randomizeFormWrapper}>
                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection("showIbmForm")}
                      >
                        <Tooltip
                          title={
                            showIbmForm
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t(
                                  "show"
                                )
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showIbmForm ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("API Management")}
                        </span>
                      </h4>

                      {showIbmForm && (
                        <div>
                          <PatientIBMProcessing
                            subjectID={subjectID}
                            ibm_api_data_changed={get(
                              subject,
                              "profile.ibm_api_data_changed"
                            )}
                            ecoa_subject={get(subject, "profile.ecoa_subject")}
                            subject_api_connections={get(subject, "api_connections.data")}
                            status_obj={{
                              status: get(subject, "profile.ibm_status"),
                              comment: get(subject, "profile.ibm_comments"),
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}

                {subject && subject.consent_event_status !== "not_required" && (
                  <div className={classes.randomizeFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showConsent")}
                    >
                      <Tooltip
                        title={
                          this.state.showConsent
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              this.state.showConsent ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("Consent")}
                      </span>
                    </h4>

                    {this.state.showConsent && (
                      <div>
                        {this.props.consentAccessPermission ? (
                          <div style={{ margin: "20px" }}>
                            {subject.consent_data &&
                            subject.consent_data.consentExistsLink &&
                            subject.consent_data.consentExistsLink.length >
                              0 ? (
                              map(
                                subject.consent_data.consentExistsLink,
                                ({ link, name, private_url }, i) => (
                                  <div key={i}>
                                    {link ? (
                                      <FileLink
                                        url={link}
                                        private_url={private_url}
                                        text={name}
                                      />
                                    ) : (
                                      <div style={{ margin: "0 0 10px" }}>
                                        <div style={{ margin: "0 0 5px" }}>
                                          {this.props.i18n.t(
                                            "Consent file missing."
                                          )}
                                        </div>

                                        {!this.state.show_voided && <Link
                                          to={withParams(routes.admin.consent, {
                                            subjectID: get(subject, "code"),
                                            site: get(subject, "site.code"),
                                          })}
                                        >
                                          <Button size="small" type="primary">
                                            {this.props.i18n.t(
                                              "Provide Consent"
                                            )}
                                          </Button>
                                        </Link>}
                                      </div>
                                    )}
                                  </div>
                                )
                              )
                            ) : (
                              <div style={{ margin: "0 0 10px" }}>
                                  {subject.consent_data &&
                                  !subject.consent_data.details.consent_upload_later && (
                                    <span>
                                      <div
                                        style={{ margin: "0 0 5px" }}
                                      >
                                        {this.props.i18n.t(
                                          "Consent is not provided"
                                        )}
                                      </div>
                                    </span>
                                  )}
                                </div>
                            )}

                              { subject.consent_event_status == 'pending' &&
                                <div style={{ margin: "0 0 10px" }}>
                                  <span>
                                      <div
                                        style={{ margin: "0 0 5px" }}
                                      >
                                        {this.props.i18n.t(
                                          "Consent is pending"
                                        )}
                                      </div>
                                    </span>
                                </div>
                              }

                            {!this.state.show_voided &&  subject.consent_data && ((subject.consent_data.consentExistsLink &&
                              subject.consent_data.consentExistsLink.length <= 0) || (subject.consent_data.details.consent_is_needed)) && !subject.consent_data.details.consent_upload_later &&
                                <Link
                                  to={withParams(routes.admin.consent, {
                                    subjectID: get(subject, "code"),
                                    site: get(subject, "site.code"),
                                  })}
                                >
                                  <Button size="small" type="primary">
                                    {this.props.i18n.t("Provide Consent")}
                                  </Button>
                                </Link>
                              }

                              { subject.consent_data &&
                            subject.consent_data.details.consent_upload_later &&
                              <div
                                  style={{ margin: "0 0 5px" }}
                                >
                                  {subject.consent_data.consentExistsPersonType} {subject.consent_data.consentExistsMethodType} {this.props.i18n.t(
                                    "consent file upload skipped."
                                  )}
                              </div>
                            }

                            { subject.consent_data &&
                            subject.consent_data.details.consent_upload_later &&
                              <div
                                  style={{ margin: "0 0 5px" }}
                                >
                                  <Link
                                    to={withParams(
                                      routes.admin.consent,
                                      {
                                        subjectID: get(
                                          subject,
                                          "code"
                                        ),
                                        site: get(
                                          subject,
                                          "site.code"
                                        ),
                                      }
                                    )}
                                  >
                                    <Button
                                      size="small"
                                      type="primary"
                                    >
                                      {this.props.i18n.t(
                                        "Upload missing consent file"
                                      )}
                                    </Button>
                                  </Link>
                              </div>
                            }


                            { subject.consent_missing &&
                              <div
                                  style={{ margin: "0 0 5px" }}
                                >
                                <div
                                  style={{ margin: "0 0 5px" }}
                                >
                                  {this.props.i18n.t(
                                    "Consent is missing"
                                  )}
                                </div>

                                {!this.state.show_voided && <Link
                                    to={withParams(
                                      routes.admin.consent,
                                      {
                                        subjectID: get(
                                          subject,
                                          "code"
                                        ),
                                        site: get(
                                          subject,
                                          "site.code"
                                        ),
                                      }
                                    )}
                                  >
                                    <Button
                                      size="small"
                                      type="primary"
                                    >
                                      {this.props.i18n.t(
                                        "Provide consent"
                                      )}
                                    </Button>
                                  </Link>}
                              </div>
                            }


                            {subject.consent_data &&
                              subject.consent_data.consentExistsEmailStatus && (
                                <div>
                                  {subject.consent_data
                                    .consentExistsEmailStatus ===
                                    "participant_email_sent" && (
                                    <span>
                                      {" "}
                                      {this.props.i18n.t("Waiting for participant signature")}
                                    </span>
                                  )}
                                  {subject.consent_data
                                    .consentExistsEmailStatus ===
                                    "investigator_email_sent" && (
                                    <span>
                                      {" "}
                                      {this.props.i18n.t("Waiting for investigator signature")}
                                    </span>
                                  )}
                                  {subject.consent_data
                                    .consentExistsEmailStatus ===
                                    "investigator_link_expired" && (
                                    <span> {this.props.i18n.t("Investigator link expired")}</span>
                                  )}
                                  {subject.consent_data
                                    .consentExistsEmailStatus ===
                                    "link_expired" && (
                                    <span> {this.props.i18n.t("Participant link expired")}</span>
                                  )}
                                </div>
                              )}
                            {subject.consent_data &&
                              subject.consent_data.consentExistsEmailStatus &&
                                !["participant_email_sent", "investigator_email_sent", "investigator_link_expired", "link_expired"].includes(subject.consent_data.consentExistsEmailStatus) && (
                                <div>
                                    <span>
                                      {" "}
                                      {subject.consent_data.consentExistsEmailStatus}
                                    </span>
                                </div>
                              )}

                            {subject.consent_data &&
                              subject.consent_data.consentExistsDate && (
                                <div>
                                  <b>{this.props.i18n.t("Date")}:</b>{" "}
                                  {`${moment
                                    .utc(subject.consent_data.consentExistsDate)
                                    .tz(
                                      userTimezone ||
                                        get(subject, "site.time_zone") ||
                                        "UTC"
                                    )
                                    .format("YYYY/MM/DD HH:mm")} ${
                                    userShortTimezone ||
                                    get(subject, "site.short_tz") ||
                                    "UTC"
                                  }`}
                                </div>
                              )}

                            {subject.consent_data &&
                            subject.consent_data.consentExists && (
                              <div>
                                <b>{this.props.i18n.t("Consent exists")}:</b>{" "}
                                {subject.consent_data.consentExists ? this.props.i18n.t('Yes') : this.props.i18n.t('No')}
                              </div>
                            )}

                            {subject.consent_data &&
                            subject.consent_data.consentExistsType && (
                              <div>
                                <b>{this.props.i18n.t("Consent type")}:</b>{" "}
                                {subject.consent_data.consentExistsType}
                              </div>
                            )}

                            {subject.consent_data &&
                            subject.consent_data.consentExistsPersonType && (
                              <div>
                                <b>{this.props.i18n.t("Consent person")}:</b>{" "}
                                {subject.consent_data.consentExistsPersonType}
                              </div>
                            )}

                            {subject.consent_data &&
                            subject.consent_data.consentExistsMethodType && (
                              <div>
                                <b>{this.props.i18n.t("Consent method")}:</b>{" "}
                                {subject.consent_data.consentExistsMethodType}
                              </div>
                            )}

                            {subject.consent_data &&
                            subject.consent_data.consentComments && (
                              <div>
                                <b>{this.props.i18n.t("Comments")}:</b>{" "}
                                {subject.consent_data.consentComments}
                              </div>
                            )}

                            {subject.consent_data &&
                            subject.consent_data.consentTimeSpend ? (
                              <div>
                                <b>{this.props.i18n.t("Time spent")}:</b>{" "}
                                {subject.consent_data.consentTimeSpend}s
                              </div>
                            ) : (
                              <div />
                            )}

                            {subject.consent_data && subject.consent_data.can_resend_email && (
                              <div style={{ marginTop: "5px" }}>
                                <Button
                                  onClick={() => {
                                    this.resendConsentEmail(
                                      subject.consent_data.consentRecordID
                                    );
                                  }}
                                  size="small"
                                  type="primary"
                                  htmlType="button"
                                  loading={resendConsentNotificationLoading}
                                  disabled={resendConsentNotificationSuccess}
                                >
                                  {this.props.i18n.t("Resend consent email")}
                                </Button>
                              </div>
                            )}

                            {subject.consent_data &&
                              subject.consent_data.language_code ? (
                                <div>
                                  <b>{this.props.i18n.t("Language")}:</b>{" "}
                                  {subject.consent_data.language_code.toUpperCase()}
                                </div>
                              ) : (
                                <div />
                              )}

                            {(subject.consent_data && subject.consent_data.consentExistsLink &&
                              subject.consent_data.consentExistsLink.length >= 0 && !subject.consent_data.details.consent_is_needed && !subject.consent_data.details.consent_upload_later && subject.consent_data.details.can_update_consent) &&
                                <div>
                                  <br/>
                                  <Link
                                    to={withParams(routes.admin.consent, {
                                      subjectID: get(subject, "code"),
                                      site: get(subject, "site.code"),
                                    })}
                                  >
                                    <Button size="small" type="link">

                                      {this.props.i18n.t("Update consent")}
                                    </Button>
                                  </Link>
                                </div>
                            }

                          </div>
                        ) : (
                          <div style={{ margin: "24px" }}>{this.props.i18n.t("No access")}</div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {!this.state.show_voided && isValidationRequired && subject && (
                  <div className={classes.randomizeFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection(
                        "showValidateRandomization"
                      )}
                    >
                      <Tooltip
                        title={
                          showValidateRandomization
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              showValidateRandomization ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("Validate Randomization")}
                      </span>
                    </h4>

                    {showValidateRandomization && (
                      <div>
                        {subject.validation &&
                          subject.validation.length === 0 && (
                            <div>
                              {this.props.i18n.t("Validation is not conducted")}
                            </div>
                          )}
                        {map(subject.validation, (validation) => (
                          <List
                            header={
                              <b>{`${moment
                                .utc(validation.validation_date)
                                .tz(
                                  userTimezone ||
                                    get(subject, "site.time_zone") ||
                                    "UTC"
                                )
                                .format("YYYY/MM/DD HH:mm")} ${
                                userShortTimezone ||
                                get(subject, "site.short_tz") ||
                                "UTC"
                              }`}</b>
                            }
                            itemLayout="horizontal"
                            dataSource={[
                              {
                                title: this.props.i18n.t("State"),
                                description: validation.state,
                              },
                              {
                                title: this.props.i18n.t("Validation comments"),
                                description: validation.validation_comments,
                              },
                              {
                                title: this.props.i18n.t(
                                  "Protocol deviation comments"
                                ),
                                description:
                                  validation.protocol_deviation_comments,
                              },
                              {
                                title: this.props.i18n.t(
                                  "Patient death comments"
                                ),
                                description: validation.patient_death_comments,
                              },
                            ]}
                            renderItem={(item) => (
                              <List.Item>
                                <List.Item.Meta
                                  title={item.title}
                                  description={item.description}
                                />
                              </List.Item>
                            )}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {subject && projectConfigurationPreRandomization && (
                  <div className={classes.randomizeFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showPreRandomizeForm")}
                    >
                      <Tooltip
                        title={
                          showPreRandomizeForm
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              showPreRandomizeForm ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("Pre-Randomization Information")}
                      </span>
                      &nbsp;
                      {/*{get(subject, 'profile') && <Badge count={get(subject, 'profile.locked') ? `Locked by ${get(subject, 'profile.locked_by_username')}` : 'Unlocked'} style={{ backgroundColor: get(subject, 'profile.locked') ? '#f00' : '#49c850', textTransform: 'none' }} />}*/}
                    </h4>

                    {showPreRandomizeForm && (
                      <div>
                        <Row>
                          <Col md={24} lg={18}>
                            <FormBuilderCustomViewContainer
                              slug="pre_randomization"
                              subjectID={subject.profile.code}
                              isModal={false}
                              isEditable={false}
                              site={subject.site}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                )}

                {subject && (
                  <div className={classes.randomizeFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showRandomizeForm")}
                    >
                      <Tooltip
                        title={
                          showRandomizeForm
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              showRandomizeForm ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("Randomization Information")}
                      </span>
                      &nbsp;
                      {/*{get(subject, 'profile') && <Badge count={get(subject, 'profile.locked') ? `Locked by ${get(subject, 'profile.locked_by_username')}` : 'Unlocked'} style={{ backgroundColor: get(subject, 'profile.locked') ? '#f00' : '#49c850', textTransform: 'none' }} />}*/}
                    </h4>

                    {showRandomizeForm && (
                      <div>
                        <RandomizeAdmin
                          subject={subject}
                          dispensingSites={dispensingSites}
                          getSubject={this.getSubject}
                          onRandomized={this.onRandomized}
                          isEditableRandomize={isEditable}
                          site={subject.site}
                          profile={subject.profile}
                          profileCopy={subject.profile_copy}
                          drug_location={subject.drug_location}
                          subjectID={subjectID}
                          randomizationConducted={
                            subject.randomization_conducted
                          }
                          profileCode={get(subject, "profile.code")}
                          onSubmit={this.onSubjectSearch}
                        />
                        <Row>
                          <Col md={24} lg={18}>
                            <FormBuilderCustomViewContainer
                              slug="randomization"
                              subjectID={subject.profile.code}
                              isModal={false}
                              isEditable={false}
                              site={subject.site}
                            />
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                )}

                {subject && this.props.isDrugManagementActive && (
                  <div className={classes.registryFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showReallocationForm")}
                    >
                      <Tooltip
                        title={
                          showReallocationForm
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              showReallocationForm ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t(
                          "NamespacePatientProfile:Drug Reallocation"
                        )}
                      </span>
                    </h4>

                    {showReallocationForm && (
                      <div>
                        {subject.randomization_conducted ? (
                          <PatientReallocationForm
                            isEditableRegistry={
                              patientProfileUpdatePermission && profile
                            }
                            {...subject}
                            current_drug={current_drug}
                            subjectID={subjectID}
                            onSubmit={this.onSubjectSearch}
                            logout={this.props.logout}
                          />
                        ) : (
                          this.props.i18n.t(
                            "NamespacePatientProfile:No randomization data"
                          )
                        )}
                      </div>
                    )}
                  </div>
                )}

                {subject &&
                  unblindingRequestReadPermission && get(subject, "randomization_conducted") && (
                    <div className={classes.registryFormWrapper}>
                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection("showRegistryForm")}
                      >
                        <Tooltip
                          title={
                            showRegistryForm
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t(
                                  "show"
                                )
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showRegistryForm ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t(
                            "NamespacePatientProfile:Unblinding"
                          )}
                        </span>
                      </h4>

                      {showRegistryForm && (
                        <div>
                          <PatientRegistryForm
                            isEditableRegistry={
                              patientProfileUpdatePermission && profile
                            }
                            {...subject}
                            comments=''
                            subjectID={subjectID}
                            onSubmit={this.onSubjectSearch}
                            logout={this.props.logout}
                          />
                        </div>
                      )}
                    </div>
                  )}

                {/*{subject && showProfileForm && (
                  <PatientProfileForm
                    randomized={randomized}
                    history={this.props.history}
                    onSubjectClear={this.onSubjectClear}
                    {...subject}
                    dispensingSites={dispensingSites}
                    subjectID={subjectID}
                    onSubmit={this.onSubjectSearch}
                    getSubject={this.getSubject}
                    onProfileDelete={this.onProfileDelete}
                  />
                )}*/}

                <div className={classes.registryFormWrapper}>
                  <h4
                    className={classnames(
                      "headline-default",
                      classes.toggleHeadline
                    )}
                    onClick={this.collapseSection("showPatientProfileForm")}
                  >
                    <Tooltip
                      title={
                        showPatientProfileForm
                          ? this.props.i18n.t(
                              "collapse"
                            )
                          : this.props.i18n.t("show")
                      }
                    >
                      <Icon
                        type="arrow-up"
                        className={classes.collapseIcon}
                        style={{
                          fontSize: "20px",
                          transform: `rotate(${
                            showPatientProfileForm ? "0" : "180deg"
                          })`,
                        }}
                      />{" "}
                      &nbsp;
                    </Tooltip>
                    <span className={classes.toggleText}>
                      {this.props.i18n.t(
                        "NamespacePatientProfileForm:Patient Profile"
                      )}
                    </span>
                    &nbsp;
                    <Badge
                      count={
                        profile
                          ? this.props.i18n.t("Edit")
                          : this.props.i18n.t("New")
                      }
                      style={{ backgroundColor: "#2968AE" }}
                    />
                    &nbsp;
                    {subject && (
                      <Badge
                        count={subject.state}
                        style={{
                          backgroundColor:
                            subject.state === "active" ? "#49c850" : "#f00",
                        }}
                      />
                    )}
                    &nbsp;
                    {profile && (
                      <Badge
                        count={
                          locked
                            ? `${this.props.i18n.t("Locked by")} ${get(
                                profile,
                                "locked_by_username"
                              )}`
                            : this.props.i18n.t("Unlocked")
                        }
                        style={{
                          backgroundColor: locked ? "#f00" : "#49c850",
                          textTransform: "none",
                        }}
                      />
                    )}
                    &nbsp;
                    {profile && profile.locked_date && (
                      <Badge
                        count={`Locked at ${moment
                          .utc(profile.locked_date)
                          .tz(
                            this.props.userTimezone ||
                              get(subject, "site.time_zone") ||
                              "UTC"
                          )
                          .format("YYYY-MM-DD HH:mm")} ${
                          this.props.userShortTimezone ||
                          get(subject, "site.short_tz") ||
                          "UTC"
                        }`}
                        style={{
                          backgroundColor: "#f00",
                          textTransform: "none",
                        }}
                      />
                    )}
                  </h4>

                  {showPatientProfileForm && get(subject, "randomization_conducted") && (
                    <div>
                      {subject && (
                        <PatientProfileFormRandomization
                          randomized={randomized}
                          site={subject.site}
                          subject={subject}
                          history={this.props.history}
                          onSubjectClear={this.onSubjectClear}
                          profile={subject.profile}
                          dispensingSites={dispensingSites}
                          subjectID={subjectID}
                          onSubmit={this.onSubjectSearch}
                          getSubject={this.getSubject}
                          onProfileDelete={this.onProfileDelete}
                        />
                      )}
                    </div>
                  )}

                  {!get(subject, "randomization_conducted") && !this.state.show_voided && (
                    <div>
                      <Row>
                        <Col md={24} lg={18}>
                          <a
                            href={withParams(routes.admin.randomize, {
                              subjectCode: get(subject, "code"),
                              siteCode: get(
                                subject,
                                "site.code"
                              ),
                            })}
                          >
                            <Button size="small" type="primary">
                              {this.props.i18n.t(
                                "Randomize subject"
                              )}
                            </Button>
                          </a>
                        </Col>
                      </Row>
                    </div>
                  )}
                </div>

                {subject && (
                  <PatientProfileEventSummary
                    randomized={randomized}
                    history={this.props.history}
                    onSubjectClear={this.onSubjectClear}
                    {...subject}
                    dispensingSites={dispensingSites}
                    subjectID={subjectID}
                    onSubmit={this.onSubjectSearch}
                    getSubject={this.getSubject}
                  />
                )}

                {subject && this.props.patientDocumentReadPermission && (
                  <div className={classes.registryFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showDocumentsSection")}
                    >
                      <Tooltip
                        title={
                          showDocumentsSection
                            ? this.props.i18n.t(
                                "collapse"
                              )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              showDocumentsSection ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("Documents")}
                      </span>
                    </h4>

                    {showDocumentsSection && (
                      <div>
                        <div>
                          {patientDocumentCreatePermission && (
                            <div>
                              <Button type="primary" onClick={this.addDocument}>
                                {this.props.i18n.t("Add new document")}
                              </Button>
                              <br />
                              <br />
                            </div>
                          )}

                          <Modal
                            visible={!!documentEdit}
                            onCancel={this.onDocumentEditHide}
                            footer={null}
                          >
                            {documentEdit && (
                              <DocumentPatientForm
                                {...documentEdit}
                                patient={subject}
                                withPatient
                                isNew={documentEdit && !documentEdit.id}
                                onSubmit={this.onDocumentEditSubmit}
                                onCancel={this.onDocumentEditHide}
                              />
                            )}
                          </Modal>
                        </div>
                        <div>
                          {get(subject, "profile.documents") && (
                            <Table
                              columns={this.documentColumns()}
                              onChange={this.handleTableChange}
                              dataSource={sortBy(
                                get(subject, "profile.documents", []),
                                (item) =>
                                  order === "asc"
                                    ? -item.order_index
                                    : item.order_index
                              )}
                              loading={isLoading}
                              rowKey="id"
                              pagination={false}
                            />
                          )}
                        </div>

                        {this.props.consentAccessPermission &&
                          subject.consent_data &&
                          subject.consent_data.consentExistsLink && (
                            <div>
                              <br />
                              <Table
                                columns={[
                                  {
                                    dataIndex: "name",
                                    key: "name",
                                    title: this.props.i18n.t("Name"),
                                    render: (val) => <span>{val}</span>,
                                  },
                                  {
                                    dataIndex: "link",
                                    key: "link",
                                    title: this.props.i18n.t("Link"),
                                    render: (val, row) => (
                                      <FileLink
                                        url={val}
                                        private_url={row.private_url}
                                      />
                                    ),
                                  },
                                ]}
                                dataSource={get(
                                  subject,
                                  "consent_data.consentExistsLink",
                                  []
                                )}
                                rowKey="name"
                                pagination={false}
                              />
                              <br />
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                )}



                {!this.state.show_voided && subject && this.props.getSpecimenSampleReadPermission && (
                  <div className={classes.registryFormWrapper}>
                    <h4
                      className={classnames(
                        "headline-default",
                        classes.toggleHeadline
                      )}
                      onClick={this.collapseSection("showSpecimenSection")}
                    >
                      <Tooltip
                        title={
                          this.state.showSpecimenSection
                            ? this.props.i18n.t(
                            "collapse"
                            )
                            : this.props.i18n.t("show")
                        }
                      >
                        <Icon
                          type="arrow-up"
                          className={classes.collapseIcon}
                          style={{
                            fontSize: "20px",
                            transform: `rotate(${
                              this.state.showSpecimenSection ? "0" : "180deg"
                            })`,
                          }}
                        />{" "}
                        &nbsp;
                      </Tooltip>
                      <span className={classes.toggleText}>
                        {this.props.i18n.t("Specimen samples")}
                      </span>
                    </h4>

                    {this.state.showSpecimenSection && (
                      <div>
                        <SpecimenSample subjectID={subject.profile.code} />
                      </div>
                    )}
                  </div>
                )}

                {isLoading && <Icon type="loading" />}
              </div>
            )}

            {formEventSlug && (
              <FormBuilderCustomViewContainer
                site={subject.site}
                slug={formEventSlug}
                subjectID={subject.profile.code}
                onCancel={() => {
                  this.setState({ formEventSlug: null });
                }}
                onSubmit={() => {
                  this.setState({ formEventSlug: null });
                  this.getEvents();
                }}
              />
            )}

            {formEventSlugPreview && (
              <FormBuilderCustomViewContainer
                site={subject.site}
                slug={formEventSlugPreview}
                subjectID={subject.profile.code}
                isEditable={false}
                onCancel={() => {
                  this.setState({ formEventSlugPreview: null });
                }}
                isPreview
              />
            )}

            <Modal
              visible={!!formIssuePreview}
              onCancel={() => {
                this.setState({ formIssuePreview: null });
              }}
              footer={null}
            >
              {formIssuePreview && (
                <QualityControlForm
                  site={subject.site}
                  custom_form={formIssuePreview}
                  subject_id={subject.id}
                  onSubmit={() => {
                    this.setState({ formIssuePreview: null });
                  }}
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state,
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  patientDocumentCreatePermission: getPatientDocumentCreatePermission(state),
  patientDocumentReadPermission: getPatientDocumentReadPermission(state),
  patientProfileUpdatePermission: getPatientProfileUpdatePermission(state),
  patientProfileReadPermission: getPatientProfileReadPermission(state),
  patientProfileRegistryIdPermission: gePatientProfileRegistryIdPermission(
    state
  ),
  unblindingRequestReadPermission: getUnblindingRequestReadPermission(state),
  profileDrugReallocatePermission: getProfileDrugReallocatePermission(state),
  dispensingSites: getSettingsDispensingSites(state),
  apiIbmUpdatePermission: getApiIbmUpdatePermission(state),
  apiEcoaUpdatePermission: getApiEcoaUpdatePermission(state),
  apiImednetUpdatePermission: getApiImednetUpdatePermission(state),
  apiDatafaxUpdatePermission: getApiDatafaxUpdatePermission(state),
  projectConfigurationPreRandomization: getProjectConfigurationPreRandomization(
    state
  ),
  isDrugManagementActive: getDrugManagementStatus(state),
  isValidationRequired: getValidationRequiredStatus(state),
  validateRandomizationAccessPermission: getValidateRandomizationAccessPermission(state),
  consentAccessPermission: getConsentAccessPermission(state),
  getRunRedcapApiConfigPermission: getRunRedcapApiConfigPermission(
    state
  ),
  getRunDFDiscoverApiConfigPermission: getRunDFDiscoverApiConfigPermission(
    state
  ),
  getSAEReadPermission: getSAEReadPermission(state),
  getSpecimenSampleReadPermission: getSpecimenSampleReadPermission(state),


});

const mapDispatchToProps = { getSettingsSites, logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(PatientProfile))
);



// WEBPACK FOOTER //
// ./src/containers/PatientProfile/PatientProfile.js